module.exports = __webpack_public_path__ + "img/c.15daf63e.jpg";